import './CommunityMember.scss'
import CommunityMemberProps from './CommunityMemberProps';
import { FaWhatsapp as WhatsappIcon } from "react-icons/fa";
import facultyImage from './../../../../assets/images/bag-icon.svg';
import participantImage from './../../../../assets/images/education-icon.svg';
import avatar from './../../../../assets/images/avatar.png';
import { useEffect, useState } from 'react';


const CommunityMember = (props: CommunityMemberProps) => {
    const { member, onPopup, sidebarRouteData, currentCourse } = props;
    const [membership, setMembership] = useState<any>(undefined);

    useEffect(() => {
        const getMembership = () => {
            if (sidebarRouteData && currentCourse) {
                const _membership = member.roles?.find((m: any) => currentCourse.communities.find((cc: any) => m.communityId === cc._id));
                if (_membership) {
                    setMembership(_membership)
                }
            }
        }
        getMembership();
    }, [])

    return member ? (
        <div className="community-member py-3 px-3">
            <div className="left">
                {member.image ? <img className="member-photo" src={member.image} alt='member' loading="lazy" /> : <img className="member-photo" src={avatar} alt='member' loading="lazy"/>}
                {onPopup ?
                    <div className="member-details">
                        <div className="d-flex">
                            <div className="member-name mr-2">{member.fullName ? member.fullName : member.firstName}</div>
                            {membership ? membership?.role === 'participant' ? <img src={participantImage} alt="icon" /> : <img src={facultyImage} alt="icon" /> : null}
                        </div>
                        <div className="member-program">{member.program}</div>
                    </div>
                    :
                    <div className="member-details">
                        <div className="member-name">{member.fullName}</div>
                        <div className="member-program">{member.title}</div>
                    </div>
                }
            </div>
            <div className="right">
                {onPopup ?
                    <div className="box">
                        <a href={`tel:${member.phone}`}>
                            <WhatsappIcon className="icon" />
                        </a>
                    </div>
                    :
                    membership ? membership?.role === 'participant' ? <img src={participantImage} alt="icon" /> : <img src={facultyImage} alt="icon" /> : null
                }
            </div>
        </div>
    ) : null
}

export default CommunityMember;